import { ParagraphText, StackLayout } from '@leagueplatform/genesis-core';
import {
  FormStatusPill,
  FormStatusCategory,
} from 'components/form-statuses/form-status-pill.component';

interface StatusDefinitionRendererProps {
  body?: {
    tags?: { label?: string; category?: string }[];
    subheading?: string;
  };
}

export const StatusDefinitionRenderer = ({
  body,
}: StatusDefinitionRendererProps) => {
  const tag = body?.tags?.[0];
  return (
    <StackLayout
      orientation="vertical"
      spacing="$half"
      horizontalAlignment="start"
    >
      {tag && (
        <FormStatusPill
          label={tag.label ?? ''}
          category={(tag.category ?? 'neutral') as FormStatusCategory}
          labelTone="category"
        />
      )}
      {body?.subheading && (
        <ParagraphText css={{ width: '100%' }}>{body.subheading}</ParagraphText>
      )}
    </StackLayout>
  );
};
